import {
  bottomContainer,
  copyrightContainer,
  footerContainer,
  formContainer,
  mainContainer,
  scrollUpContainer,
} from "./components/styles.css";
import { LinksBlock } from "./components/LinksBlock";
import { TextLink } from "../../../components/link/TextLink";
import { ButtonIcon } from "../../../components/link/ButtonIcon";
import { ChevronUpIcon } from "../../../components/icons/ChevronUpIcon";
import classNames from "classnames";
import { HTMLAttributes, RefObject } from "react";
import { MAIL_TO_EMAIL } from "../../../constants/links";
import { responsiveIconSizes } from "../../../styles/responsive.css";
import { PRIVACY_POLICY_PAGE } from "../../../../providers/routing/routes";

type FooterProps = {
  onScrollToTop?: () => void;
  footerBottomRef?: RefObject<HTMLDivElement>;
} & Pick<HTMLAttributes<HTMLDivElement>, "id">;

export const Footer = ({
  onScrollToTop,
  className,
  id,
  footerBottomRef,
}: FooterProps & StyledProps) => {
  return (
    <div id={id} className={classNames(footerContainer, className)}>
      <div className={formContainer}>
        <div className={mainContainer}>
          <span>
            AI-powered architecture, robot&#8209;powered construction.
          </span>
          <span>
            <TextLink to={`mailto:${MAIL_TO_EMAIL}`}>Sign up</TextLink> for
            updates or{" "}
            <TextLink to={`mailto:${MAIL_TO_EMAIL}`}>
              cost your project now
            </TextLink>
          </span>
        </div>
      </div>
      <div ref={footerBottomRef} className={bottomContainer}>
        <LinksBlock />
        <div className={copyrightContainer}>
          ©&nbsp;2025&nbsp;All3. All&nbsp;rights&nbsp;reserved.
          <br />
          Check&nbsp;our{" "}
          <TextLink to={PRIVACY_POLICY_PAGE}>privacy policy</TextLink>
        </div>
      </div>
      <div className={scrollUpContainer}>
        <ButtonIcon
          primary
          onClick={() => {
            onScrollToTop?.();
          }}
        >
          <ChevronUpIcon className={responsiveIconSizes} />
        </ButtonIcon>
      </div>
    </div>
  );
};
